import { FunctionHeader } from "./FunctionHeader";
import { FunctionArguments } from "./FunctionArguments";
import { RawJSONDisplay } from "./RawJSONDisplay";

interface ToolCallItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toolCall: any;
  showRawJSON: boolean;
  onToggle: () => void;
  className?: string;
}

export const ToolCallItem = ({
  toolCall,
  showRawJSON,
  onToggle,
  className = "",
}: ToolCallItemProps) => (
  <div className={className}>
    <FunctionHeader name={toolCall.function.name} showRawJSON={showRawJSON} onToggle={onToggle} />
    {showRawJSON ? (
      <RawJSONDisplay data={toolCall} />
    ) : (
      <FunctionArguments args={toolCall.function.arguments} />
    )}
  </div>
);
